import styled from 'styled-components';
import Img from 'react-image';
const ListViewWrapper = styled('div')`
  width: 100%;
  display: flex;
  transition: 0.3s;
  background-color: white;
  height: 230px;
  :hover {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .12);
  }
  @media only screen and (max-width: 580px) {
    height: 145px;
  }
`;

const ImageWrapper = styled('div')`
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  display: inline-block;
  height: 100%;
  width: 38%;
  img {
    object-fit: cover;
    height: 230px;
    width: 100%;
    @media (max-width: 580px) {
      height: 145px;
    }
  }
`;
const Image = styled(Img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ContentWrap = styled('div')`
  width: 62%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 15px;
  color: #999;
  position: relative;
  @media (max-width: 580px) {
    padding: 12px 15px;
    .category,
    .town {
      margin-bottom: 0;
    }
  }
  a {
    color: inherit;
    transition-duration: 0.4s;
    z-index: 100;
    &:hover {
      color: #00bcd4;
    }
  }
  i:last-child {
    transition-duration: 0.4s;
    cursor: pointer;
    z-index: 100;
    &:hover {
      color: #00bcd4;
    }
  }
  h2 {
    transition-duration: 0.4s;
    cursor: pointer;
    &:hover {
      color: black;
      text-decoration: underline;
    }
  }
`;

const AddressAndDate = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const SubCardInfosWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  width: 100%;
  margin-bottom: 10px;
`;

const SubCardDescriptionWrapper = styled('div')`
  display: block;
  font-size: 15px;
  width: 100%;
  line-height: 24px;
  color: #868686;
  margin-top: 10px;
  @media (max-width: 580px) {
    display: none;
  }
  span {
    &:before {
      content: '...';
    }
  }
`;

const SubCardTitleWrapper = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 10px;
  h2 {
    margin: 0 0 0 0;
  }
  @media (max-width: 580px) {
    h2 {
      font-size: 16px !important;
    }
  }
  h2 &:hover {
    text-decoration: underline;
  }
`;

const SubCardPriceWrapper = styled('div')`
  color: #00bcd4;
  font-weight: bold;
  width: 100%;
  margin-top: 10px;
  @media (max-width: 580px) {
    p {
      margin-bottom: 0;
    }
  }
`;

const SubCardCenterWrapper = styled('div')`
  width: 100%;
  height: 100%;
`;

export {
  ListViewWrapper,
  ImageWrapper,
  Image,
  ContentWrap,
  AddressAndDate,
  SubCardInfosWrapper,
  SubCardDescriptionWrapper,
  SubCardTitleWrapper,
  SubCardPriceWrapper,
  SubCardCenterWrapper,
};
